import { AdminTilesWorkspace } from "./AdminTilesWorkspace";

export default function TilesPage() {
  return <AdminTilesWorkspace />;
}
